import RegistrationQuizByType from "./RegistrationQuizByType";

export default RegistrationQuizByType;
